// const getNavigatorLocale = () => (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en';

const defaultLocale = 'en-US';
const defaultTimeZone = '';

export const defaultCurrencyCode = 'usd';

export const systemIsSupportingIntl = typeof Intl !== 'undefined' && Intl.DateTimeFormat !== undefined;

export const systemIsHour12 = new Intl.DateTimeFormat(systemIsSupportingIntl, { hour: 'numeric' }).resolvedOptions().hour12;

export function getSystemLocale() {
  if (!systemIsSupportingIntl) return defaultLocale;

  return new Intl.DateTimeFormat().resolvedOptions().locale;
}

export function getSystemTimeZone() {
  if (!systemIsSupportingIntl) return defaultTimeZone;

  return new Intl.DateTimeFormat().resolvedOptions().timeZone;
}
